import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { ModalBasicComponent } from '../common/dialogs/modal-basic/modal-basic.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ContratoAfilmedDTO } from '../../models/contrato-afilmed/contrato-afilmed.model';
import { UtilFormat } from '../../utils/format';

@Component({
  selector: 'app-contrato-card',
  templateUrl: './contrato-card.component.html',
  styleUrls: ['./contrato-card.component.css'],
})
export class ContratoCardComponent {
  @Input() contrato!: ContratoAfilmedDTO;
  @Output() viewDetails = new EventEmitter<ContratoAfilmedDTO>();
  @Input() readonly = false;
  UtilFormat = UtilFormat;
  selectedContractId?: string;

  constructor(private modalService: NgbModal) {}

  onViewClick(contrato: ContratoAfilmedDTO) {
    if (this.readonly) return;
    this.selectedContractId = contrato.contrato;
    this.viewDetails.emit(contrato);
  }

  openModal(template: TemplateRef<any>) {
    const modalRef = this.modalService.open(ModalBasicComponent, {
      centered: true,
      size: 'xl',
      windowClass: 'modal-xxl custom-modal-radius',
    });

    modalRef.componentInstance.title = 'Solicitudes pendientes por finalizar';
    modalRef.componentInstance.content = template;

    modalRef.componentInstance.buttons = [
      {
        text: 'Cerrar',
        color: 'btn-primary',
        action: 'close',
        value: true,
      },
    ];
  }

  getEstadoClass(estado: string): string {
    if (!estado) return '';

    estado = estado.trim().toLowerCase();

    if (estado.includes('activo, con servicio')) {
      return 'bg-info';
    }

    if (estado.includes('activo, sin servicio')) {
      return 'bg-danger';
    }

    if (estado.includes('activo, transitorio')) {
      return 'bg-transitorio';
    }

    return 'bg-info';
  }

  isSaldoEnMora(valor: string | number): boolean {
    return Number(valor) > 0;
  }

  isTransitorio(estado: string): boolean {
    return !!estado && estado.trim().toLowerCase().includes('transitorio');
  }
}
